import { _vars, generateQueryId } from './modules/vars';
import { bindUI} from './modules/bindui';
import { initProvider } from './modules/health-check';
import { initSCGFromUrl } from './modules/scg-handler';
import { summarizeArticle } from './features/article-summarize/summarize-controller';
import { generateToken } from './modules/providers/dify/api';
import { initCompareTreatment } from './features/compare-treatment/compare-treatment-controller';
import { initCaqModule } from './features/caq/caq-controller';
import { initSearchResults } from './features/search-results/search-results-controller';
import { initDrugPrompts } from './features/drug-prompts/drug-prompts-controller';

function initialize() {
    try {
        // MEDAIS-2052: Generate initial QUERYID on page load before any DFP/Analytics/API calls
        _vars.queryId = generateQueryId();
        
        if (typeof window.aiSearchCfg == 'object') {
            Object.assign(_vars.cfg, window.aiSearchCfg);
        }
        if(PageMetadata && PageMetadata.reqHeaders && PageMetadata.reqHeaders.geoc && PageMetadata.reqHeaders.geoc === 'DE') {
            _vars.cfg.queryLimit = 0;
        }
        initSCGFromUrl();
        return initProvider().then(function(provider) {      
            if (provider) { // Only bind UI if provider is available
                window.dispatchEvent(new CustomEvent('aiSearchLibReady'));
                generateToken().then(function (data) {
                    if (data && data.token) {
                        _vars.token = 'Bearer ' + data.token;
                    }
                    initDrugPrompts();
                    summarizeArticle();
					initCompareTreatment();
					initCaqModule();
                    bindUI();
                    initSearchResults();
                }).catch(function (error) {
                    initDrugPrompts();
                    summarizeArticle();
					initCompareTreatment();
					initCaqModule();
                    bindUI();
                    initSearchResults();
                    console.log("Token generation failed");
                });
                return true;
            }
            return false;
        });
    } catch (error) {
        console.log('Failed to initialize AI Search:', error);
        return Promise.resolve(false);
    }
}
initialize().catch(function(error) {
    console.log('Failed to initialize AI Search:', error);
});

window.aiSearchInitialize = initialize;

